import React, { useState } from 'react';
import DOMPurify from 'dompurify';
import CHECKBOX_TRUE from '../../../assets/images/checkbox_true.png';
import CHECKBOX_FALSE from '../../../assets/images/checkbox.png';

function TermsSoc({ termsContent, isChecked, onCheckChange, title = "약관 동의" }) {
    const [isOpen, setIsOpen] = useState(false);

    const handleHeaderClick = () => {
        setIsOpen(prev => !prev);
    };

    const handleCheckboxClick = (e) => {
        e.stopPropagation();
        onCheckChange(!isChecked);
    };

    const handleLabelClick = (e) => {
        e.stopPropagation();
        onCheckChange(!isChecked);
    };

    return (
        <div style={{ marginTop: "20px", width: "100%", border: "1px solid #ddd", borderRadius: "6px", background: "#fff" }}>
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "12px 20px",
                    cursor: "pointer",
                }}
                onClick={handleHeaderClick}
            >
                <div style={{ display: "flex", alignItems: "center", flex: 1, gap: "10px" }}>
                    <img
                        src={isChecked ? CHECKBOX_TRUE : CHECKBOX_FALSE}
                        alt="checkbox"
                        style={{ width: "20px", height: "20px", cursor: "pointer", flexShrink: 0 }}
                        onClick={handleCheckboxClick}
                    />
                    <span
                        onClick={handleLabelClick}
                        style={{ cursor: "pointer", fontSize: "14px", fontWeight: "500", letterSpacing: "-0.5px" }}
                    >
                        {title}
                    </span>
                </div>
                <span style={{
                    alignSelf: "center",
                    marginLeft: "auto",
                    fontSize: "1.5rem",
                    transition: "transform 0.2s",
                    transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
                    flexShrink: 0,
                }}>
                    ⌃
                </span>
            </div>
            {isOpen && (
                <div style={{
                    borderTop: "1px solid #ddd",
                    maxHeight: "300px",
                    overflowY: "auto",
                    padding: "20px",
                    fontSize: "14px",
                    color: "#777777",
                    background: "#fff",
                }}>
                    <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(termsContent || '') }} />
                </div>
            )}
        </div>
    );
}

export default TermsSoc;
